class PaletteHarmonyPicker extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[data-harmony-tab]'));
    this.videos = Array.from(this.querySelectorAll('[data-harmony-video]'));

    this.onTabClick = this.onTabClick.bind(this);
    this.onBlockSelect = this.onBlockSelect.bind(this);

    this.tabs.forEach((tab) => tab.addEventListener('click', this.onTabClick));

    this.videos.forEach((wrapper) => {
      const video = wrapper.querySelector('video');
      const media = wrapper.querySelector('video-media');
      const playButton = wrapper.querySelector('[data-harmony-play]');

      if (video) {
        video.addEventListener('play', () => {
          wrapper.classList.add('is-playing');
          // Marks this video as having genuinely played at least once, so
          // we know not to autoplay it again next time it's switched back to.
          wrapper.dataset.everPlayed = 'true';
        });
        video.addEventListener('pause', () => wrapper.classList.remove('is-playing'));
      }

      playButton?.addEventListener('click', (event) => {
        event.stopPropagation();
        // Safety net: if video-media's internal "playing" state ever gets
        // out of sync with the actual <video> element (it thinks it's
        // playing when the video is really paused), play() would silently
        // no-op. Clear the stale flag before asking it to play.
        if (media && video && media.playing && video.paused) {
          media.removeAttribute('playing');
        }
        media?.play();
      });
    });

    this.section = this.closest('.shopify-section');
    this.section?.addEventListener('shopify:block:select', this.onBlockSelect);
  }

  disconnectedCallback() {
    this.tabs.forEach((tab) => tab.removeEventListener('click', this.onTabClick));
    this.section?.removeEventListener('shopify:block:select', this.onBlockSelect);
  }

  onTabClick(event) {
    this.select(event.currentTarget.dataset.index);
  }

  onBlockSelect(event) {
    const tab = event.target.closest('[data-harmony-tab]');
    if (!tab || !this.tabs.includes(tab)) return;
    this.select(tab.dataset.index);
  }

  select(index) {
    this.tabs.forEach((tab) => {
      tab.classList.toggle('is-selected', tab.dataset.index === index);
    });

    this.videos.forEach((wrapper) => {
      const isActive = wrapper.dataset.index === index;
      const video = wrapper.querySelector('video');
      const media = wrapper.querySelector('video-media');

      if (!isActive && wrapper.classList.contains('is-active') && video) {
        // video.pause() is synchronous (unlike video-media's own pause(),
        // which goes through an async proxy) — pausing and resetting here
        // can't race, so the reset always applies immediately and reliably.
        video.pause();
        video.currentTime = 0;
      }

      wrapper.classList.toggle('is-active', isActive);

      if (isActive && !wrapper.dataset.everPlayed) {
        // Only autoplay the very first time a video is switched to.
        // Switching back to a video that's already been played (including
        // the initial pre-selected one) just resets it and waits for a
        // manual click on the play button.
        if (media && video && media.playing && video.paused) {
          media.removeAttribute('playing');
        }
        media?.play();
      }
    });
  }
}

if (!customElements.get('palette-harmony-picker')) {
  customElements.define('palette-harmony-picker', PaletteHarmonyPicker);
}